
    /**
    * 保存BD组信息
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  /**
 * BdGroupSaveParam :BdGroupSaveParam
 */
export class IReqid17209 {
  /**
   * bd组唯一编码,新增不传，修改需要传
   */
  code?: {};
  /**
   * bd组名
   */
  name?: {};
  /**
   * 省份province_id
   */
  provinceCode?: {};
  provinceCodeName?: {};
  /**
   * 初始保护天数
   */
  initProtect?: {};
  /**
   * 合作保护天数
   */
  cooperateProtect?: {};
  /**
   * -1为无期限
   */
  initProtectType?: {};
  /**
   * -1为无期限
   */
  cooperateProtectType?: {};
  /**
   * 分组人员 ,String
   */
  bds?: {}[];
}
  /**
 * YResult :YResult
 */
export class IResid17209 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid17209, IResid17209 > = (data?) =>  request({
        method: 'POST',
        url: '/bdGroup/save',
        data: data
      }) 
  export default http